import { RegionSelection } from './RegionSelection';
import { MapSelection } from './MapSelection';
import { SubMenu } from './SubMenu';
import { Section } from '@ui-kit/Section';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';

import styles from './HeaderTop.module.scss';

export const HeaderTop = (): JSX.Element => {
  return (
    <ErrorBoundaryComponent>
      <div className={styles.Wrapper}>
        <Section className={styles.Container}>
          <RegionSelection />
          <MapSelection />
          <SubMenu />
        </Section>
      </div>
    </ErrorBoundaryComponent>
  );
};
